import { render, staticRenderFns } from "./modal-tags.vue?vue&type=template&id=1875f69e&"
import script from "./modal-tags.vue?vue&type=script&lang=js&"
export * from "./modal-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports